import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'
import type { IClientUID } from '../clients'

export async function getClientLogFile(clientId: IClientUID, sysLog: boolean): Promise<ApiResponse<string>> {
    const response = await fetch(`${HOST_URL}logs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, sysLog }),
    })
    const result = (await response.json()) as ApiResponse<string>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
